import React, { useState, useRef } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./Interview.css";

const Interview = () => {
   const [looding, setLooding] = useState(false)
    const [phonenumber, setphonenumber] = useState('')
     const [regester,setregester]=useState(false)
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    age: "",
    cell: "",
    qualification: "",
    photo: null,
    district: "Kanniyakumari",
    taluk: "",
    slot: "",
    have: "", // new field for "Do you have"
  });

  const [interviewPass, setInterviewPass] = useState(null);
  const passRef = useRef();

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const checkRegistered = async (cell) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/meeting/checkregistered/${cell}`
      );
       console.log(res.data)
      return res.data;
      
    } catch (error) {
      console.error("Error checking registration:", error);
      return { registered: false };
    }
  };

  const handleSubmit = async (e) => {
  setLooding(true)
    e.preventDefault();

    const result = await checkRegistered(formData.cell);

    if (result.registered) {
      setInterviewPass(result.data);
     
      return;
    }

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}/meeting/interview`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(res.data.message || "Form submitted successfully!");

      // Fetch again to get stored photo info
      const newPass = await checkRegistered(formData.cell);
      if (newPass.registered) {
        setInterviewPass(newPass.data);
      }
    } catch (error) {
      alert(error.response?.data?.error || "Something went wrong!");
    }
    finally{
      setLooding(false)
    }
  };

  const handleDownloadPDF = async () => {
    const input = passRef.current;

    const images = input.querySelectorAll("img");
    const imageLoadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve;
          }
        })
    );

    await Promise.all(imageLoadPromises);

    const canvas = await html2canvas(input, {
      useCORS: true,
      allowTaint: false,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save("Interview_Pass.pdf");
  };




const handleClick = async () => {
  if (!phonenumber || phonenumber.length !== 10) {
    alert("Please enter a valid 10-digit phone number");
    return;
  }

  setLooding(true);
  const result = await checkRegistered(phonenumber);
  setLooding(false);

  if (result.registered) {
    setInterviewPass(result.data);
    setregester(false); // Close popup
  } else {
    alert("No registration found for this number.");
  }
};

  return (
    <div className="interview-container">
   <h6>
  Download your <span onClick={() => setregester(true)} className="blinking-text" style={{ cursor: 'pointer', color: 'red' }}>
    entry pass
  </span>
</h6>


      <h1 className="form-title">Interview Registration</h1>

      {interviewPass ? (
        <div>
          <div className="interview-pass-softblue" ref={passRef}>
            <h2>
              <span role="img" aria-label="ticket" className="icon-ticket">
                🎟️
              </span>
              Interview Pass
            </h2>

            <div className="photo-wrapper-softblue">
              <img
                src={`${process.env.REACT_APP_API}/uploads/${interviewPass.photo}`}
                alt="Candidate"
                className="pass-photo-softblue"
              />
            </div>

            <div className="info-group-softblue">

              <p>
                <strong>Tocken id:</strong> RJINT0{interviewPass.id}
              </p>
              <p>
                <strong>Name:</strong> {interviewPass.name}
              </p>
              <p>
                <strong>Gender:</strong> {interviewPass.gender}
              </p>
              <p>
                <strong>Age:</strong> {interviewPass.age}
              </p>
              <p>
                <strong>Qualification:</strong> {interviewPass.qualification}
              </p>
              <p>
                <strong>District:</strong> {interviewPass.district}
              </p>
              <p>
                <strong>Taluk:</strong> {interviewPass.taluk}
              </p>
              <p>
                <strong>Do you have:</strong> {interviewPass.have}
              </p>
              <p>
                <strong>Date:</strong> 13/ 09/2025 (SATURDAY)
              </p>
               <p>
               <strong>Time:</strong> 10:30am TO 12:00pm </p>

              <p>
                <strong>Cell:</strong> +91 {interviewPass.cell}
              </p>
            <p>
  <strong>location:</strong> Old Manickam Rice Mill, Opposite Indian Oil, Beach Road Junction.
</p>


            </div>
          </div>

          <button onClick={handleDownloadPDF} className="download-btn">
            📥 Download Ticket as PDF
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="interview-form">
          <div className="form-group">
            <label>Name</label>
            <input type="text" name="name" onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Gender</label>
            <select name="gender" onChange={handleChange} required>
              <option value="">Select Gender</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>Age</label>
            <input
              type="number"
              name="age"
              min="0"
              max="120"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group phone-input">
            <label>Cell Number</label>
            <div className="phone-wrapper">
              <span className="prefix">+91</span>
              <input
                type="text"
                name="cell"
                placeholder="Enter 10 digit number"
                maxLength="10"
                value={formData.cell}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setFormData({ ...formData, cell: value });
                  }
                }}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Qualification</label>
            <input
              type="text"
              name="qualification"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Photo</label>
            <input
              type="file"
              name="photo"
              accept="image/*"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>District</label>
            <input type="text" value="Kanniyakumari" disabled />
          </div>

          <div className="form-group">
            <label>Taluk</label>
            <select name="taluk" onChange={handleChange} required>
              <option value="">Select Taluk</option>
              <option>Agasteeswaram</option>
              <option>Kalkulam</option>
              <option>Killiyur</option>
              <option>Thiruvatar</option>
              <option>Thovalai</option>
              <option>Vilavankodu</option>
            </select>
          </div>

          {/* New question "Do you have" with radio buttons */}
          <div className="form-group">
            <label>Do you have?</label>
            <div className="checkbox-group">
              <label>
                <input
                  type="radio"
                  name="have"
                  value="Bike"
                  checked={formData.have === "Bike"}
                  onChange={handleChange}
                  required
                />
                Bike
              </label>
              <label>
                <input
                  type="radio"
                  name="have"
                  value="Smartphone"
                  checked={formData.have === "Smartphone"}
                  onChange={handleChange}
                />
                Smartphone
              </label>
              <label>
                <input
                  type="radio"
                  name="have"
                  value="Both"
                  checked={formData.have === "Both"}
                  onChange={handleChange}
                />
                Both
              </label>
              <label>
                <input
                  type="radio"
                  name="have"
                  value="None"
                  checked={formData.have === "None"}
                  onChange={handleChange}
                />
                None
              </label>
            </div>
          </div>

          {/* <div className="form-group">
            <label>Interview Slot</label>
            <select name="slot" onChange={handleChange} required>
              <option value="">Select Date</option>
              <option>24-08-2025 </option>
              <option>25-08-2025 </option>
              <option>26-08-2025 </option>
              <option>27-08-2025 </option>
              <option>28-08-2025 </option>
              <option>29-08-2025 </option>
              <option>30-08-2025 </option>
              <option>31-08-2025 </option>

            </select>
          </div> */}

         <button type="submit" className="submit-btn" disabled={looding}>
  {looding ? "Submitting..." : "Submit"}
</button>

        </form>
      )}



  {regester && (
  <div className="popup-overlay">
    <div className="popup">
      <button className="close-btn" onClick={() => setregester(false)}>✖</button>
      <h3>Check Your Registration</h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleClick();
        }}
      >
        <input
          type="text"
          name="phone"
          placeholder="Enter your phone number"
          value={phonenumber}
          onChange={(e) => setphonenumber(e.target.value.replace(/\D/g, "").slice(0, 10))}
          required
        />
        <button type="submit">Check</button>
      </form>
    </div>
  </div>
)}

    </div>
  );
};

export default Interview;
